import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  addFavorited,
  deleteFavorited,
} from '../../../../../../../Vcard/services/favorite.service';
import { getFavorites } from '../../../../../../../Vcard/actions/favorite/favorite.actions';
import { setProfileLastTouch, setProfileLastTouchFavorited } from '../../../../../../../../utils/Socialization';
//-----------------------------------------------------------------------------------------------
import './style.scss';
import { getRegion } from '../../../../../../../../utils/Region';
import { getTranslation, jsonParseTraslation } from 'utils/getTranslation';
import { getAnonymousQueryParams } from 'containers/Player/utils/getAnonymousQueryParams';
import { useNavigate } from 'react-router-dom';

//ESTE COMPONENTE AGREGA UN CONTENIDO A MI LISTA DESDE LA SEARCH RESULT CARD
export const AddListButton = ({ contentInfo }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //----SELECTORS----
  const { userhash } = useSelector(state => state.user);
  const favorites = useSelector(state => state.favorites);
  const {
    vcard_access_option_icon_addList: addList,
    vcard_access_option_icon_deleteList: removeList,
  } = useSelector(state => state.asset);
  const texts = useSelector(state => state.metadata.translations);
  const parseTranslation = jsonParseTraslation(texts);
  const myList = getTranslation(
    'vcard_access_option_button_deleteFavoritiesList_text2',
    parseTranslation,
  );

  //----STATES----
  const favoriteContent =
    favorites && favorites.find(favItem => favItem?.id === contentInfo?.id);
  const [isFavorite, setIsFavorite] = useState(!!favoriteContent);

  const handleToggleAddListClick = async e => {
    e.stopPropagation();
    const { queryParams } = getAnonymousQueryParams(contentInfo, true)
    
    if(!userhash){
      return navigate(`/${getRegion()}/login`,{
        state: queryParams,
        replace:true
      });

    }

    try {
      const params = {
        user_hash: userhash,
        object_id: contentInfo.id,
        object_type: 1,
      };

      if (!isFavorite) {
        const addResponse = await addFavorited(params);
        if (addResponse.status === '0') {
          setIsFavorite(!isFavorite);
        }
        if (addResponse.lasttouch && addResponse.lasttouch.favorited) {
          setProfileLastTouchFavorited(addResponse.lasttouch.favorited);
          dispatch(getFavorites({ user_hash: userhash }));
        }
      } else {
        const deleteResponse = await deleteFavorited(params);
        if (deleteResponse.status === '0') {
          setIsFavorite(!isFavorite);
        }
        if (deleteResponse.lasttouch && deleteResponse.lasttouch.favorited) {
          setProfileLastTouchFavorited(deleteResponse.lasttouch.favorited);
          dispatch(getFavorites({ user_hash: userhash }));
        }
      }
    } catch (error) {}
  };

  return (
    <button className="add-list-button-s" onClick={handleToggleAddListClick}>
      <img
        src={!isFavorite ? addList : removeList}
        alt="addlist"
        className="add-list-button-s__icon"
      />
      <span className="add-list-button-s__text">{` ${myList}`}</span>
    </button>
  );
};

AddListButton.propTypes = {
  contentInfo: PropTypes.object.isRequired,
};
